<ion-app>
	<ion-menu side="end" menuId="catalean-menu" (ionWillOpen)="this.onMenuOpen()" contentId="menu">
    <div class="top-container">
      <cat-download-progress *ngIf="this.platform.is('cordova')" [update]="openMenuSubject" [width]="80" class="download-container">
        <div class="icon-pause" type="pause"></div>
        <div class="icon-play" type="play"></div>
      </cat-download-progress>
    </div>

		<cat-hamburger-menu
			*ngIf="rootFilter$ | async as rootFilter"
      #hamburgerMenu
			[onMenuOpen]="openMenuSubject"
			(filterSelected)="goTo($event)"
			(clickLogout)="logout()"
			[rootFilter]="rootFilter"
		>
    </cat-hamburger-menu>
		<cat-localization-selector></cat-localization-selector>
		<div class="app-version">
			<span>{{ version }}</span>
		</div>
	</ion-menu>
	<ion-router-outlet [swipeGesture]="true" id="menu"></ion-router-outlet>
</ion-app>
